<template>
    <div class="my-mydata">
        <van-nav-bar :title="title" left-text="" @click-left="onClickLeft" left-arrow :fixed="true">
        </van-nav-bar>
        <div class="huixian1">
            <Cxdate @chaxun="chaxun"/>
            <div class="wodedata">
                <div>
                    <span class="el-icon-s-custom" style="color: #FF9609;font-size: 20px;margin-right: 8px"></span>
                    <span style="font-size: 15px;">动态分析 <span style="font-size: 10px"> 以查询时间段为准</span></span>
                </div>
                <div class="wo-shuju">
                    <div class="wo-items">
                        <div class="wo-item">
                            <span>{{yqNum}}</span>
                            <span>新增粉丝</span>
                        </div>
                        <div class="wo-item">
                            <span>{{hyNum}}</span>
                            <span>活跃粉丝</span>
                        </div>
                        <div class="wo-item">
                            <span>{{smNum}}</span>
                            <span>睡眠粉丝</span>
                        </div>
                        <div class="wo-item">
                            <span>{{jtNum}}</span>
                            <span>静态粉丝</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="huixian2">
            <div class="sousuo">
                <div class="sou-item">
                    <van-search
                            v-model="phone"
                            placeholder="请输入手机号搜索"
                            show-action
                            shape="round"
                    >
                        <div slot="action" @click="onSearch">搜索</div>
                    </van-search>
                </div>
                <van-tabs v-model="active" @click="getMember">
                    <van-tab :title="tab.plusName" :name="tab.id" v-for="tab in tabs"/>
                </van-tabs>
                <span style="font-size: 10px;padding: 0px 10px 8px 10px;display: block;">实时更新 {{currentDate}} <span>全部成员 {{count}}</span></span>
            </div>
            <div>
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
                    <div class="oo-items" :style="{ backgroundColor: item.index % 2 === 0 ? '#9187E0' : '#FD99B1' }"
                         v-for="(item,index) in list">
                        <div class="mbinfo">
                            <div v-if="item.headPortrait"><img :src="item.headPortrait" class="my-tou"/></div>
                            <div v-else>
                                <img v-if="item.sex==0" src="./../../assets/nan.png" class="my-tou"/>
                                <img v-if="item.sex==1" src="./../../assets/nan.png" class="my-tou"/>
                                <img v-if="item.sex==2" src="./../../assets/nv.png" class="my-tou"/>
                            </div>
                            <span class="spi">{{item.memberName}} <span>{{item.phone}}</span></span>
                        </div>
                        <div class="nritem">
                            <div class="sxitem">
                                <span class="l">事业部</span>
                                <span class="r">{{item.sdName}}</span>
                            </div>
                            <div class="sxitem">
                                <span class="l">PLUS</span>
                                <span class="r">{{item.pmName}}</span>
                            </div>
                            <div class="sxitem">
                                <span class="l">注册时间</span>
                                <span class="r">{{item.zcDate}}</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";
    import Cxdate from "./../components/cxdate.vue";

    export default {
        components: {Cxdate},
        data() {
            return {
                title: '我的粉丝',
                active: '',
                deptId: '',
                token: '',
                dateType: 0,
                staDate: '',
                endDate: '',
                yqNum: 0,
                hyNum: 0,
                smNum: 0,
                jtNum: 0,

                phone: '',
                count: 0,
                list: [],
                page: 1,
                loading: false,
                finished: false,

                tabs: [],
                currentDate: '',
            };
        },
        async created() {
            document.title = getDeptName()
            this.deptId = getDeptId()
            this.token = getCookie("spmToken")
            this.getCurrentDate();
            this.getPlusLevels()
            this.getSpmNewFans()
            this.getSpmFans()
        },
        methods: {
            async getPlusLevels() {
                let data = {
                    deptId: this.deptId,
                }
                let res = await this.$get("/spm/getSpmPlusLevels", data)
                this.tabs = res.list
                this.tabs.unshift(
                    {
                        id: '',
                        plusName: '全部',
                    }
                )
            },

            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.getSpmNewFans()
                this.getSpmFans()
            },
            onSearch() {
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },

            async getSpmNewFans() {
                let data = {
                    token: this.token,
                    staDate: this.staDate,
                    endDate: this.endDate,
                    dateType: this.dateType
                }
                let res = await this.$get("/spm/getSpmNewFans", data)
                this.yqNum = res.yqNum
            },

            async getSpmFans() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/spm/getSpmFans", data)
                this.hyNum = res.hyNum
                this.smNum = res.smNum
                this.jtNum = res.jtNum
            },

            getMember() {
                this.page = 1;
                this.list = [],
                    this.onLoad()
            },

            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    token: this.token,
                    phone: this.phone,
                    levelId: this.active,
                    deptId: this.deptId,
                    currentPage
                }
                let res = await this.$get("/spm/getSpmYqMembers", data)
                if (res.code == 200) {
                    const count =res.dataSet.list.length
                    const newList =res.dataSet.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },

            getCurrentDate() {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份是从 0 开始的，所以需要 +1
                const day = String(now.getDate()).padStart(2, '0');
                this.currentDate = `${year}-${month}-${day}`;
            },

            onClickLeft() {
                if (window.history.length > 1) {
                    this.$router.back();
                } else {
                    this.$router.push('/home/' + this.deptId)
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .my-mydata {
        margin: 0 auto;
        height: 100%;
        background-size: 100% 100%;
        background-color: #FFFFFF;
        position: relative;
        padding-top: 46px;
        overflow: auto;
        border-left: #EFEFEF solid 5px;
        border-right: #EFEFEF solid 5px;
    }

    .wodedata {
        width: 95%;
        margin: auto;
        padding: 0 12px;
        margin-bottom: 5px;
    }

    .wo-shuju {
        display: flex;
        flex-direction: column;
        font-size: 13px;
    }

    .wo-items {
        display: flex;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        margin-top: 18px
    }

    .wo-item {
        width: 33%;
        display: flex;
        flex-direction: column;
    }

    .wo-item span {
        height: 28px;
        line-height: 28px;
    }

    .sousuo {
        background-color: #FFFFFF;
        padding-top: 10px;
    }

    .sou-item {
        padding: 0 38px;
    }

    .mbinfo {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .my-tou {
        height: 25px;
        width: 25px;
    }

    .spi {
        font-size: 12px;
        height: 25px;
        line-height: 25px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 8px;
        margin-top: 3px;
        color: #FFFFFF;
    }

    .oo-items {
        background-color: #FFFFFF;
        margin: 10px;
        padding: 0 18px 10px 18px;
    }

    .huixian1 {
        border-top: #EFEFEF solid 6px;
    }

    .huixian2 {
        border-top: #EFEFEF solid 6px;
    }

    .nritem {
        background-color: #FFFFFF;
        font-size: 12px;
        border-radius: 3px;
        margin-top: 8px;
        padding: 8px 18px;
    }

    .sxitem {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 25px;
    }

    .sxitem .l {
        width: 30%;
    }

    .sxitem .r {
        width: 70%;
    }

    /deep/ .van-tabs__wrap {
        height: 38px;
    }

    /* 隐藏原生的下划线 */
    /deep/ .van-tabs__line {
        opacity: 0;
    }

    /* 添加一个自定义的边框 */
    /deep/ .van-tab {
        position: relative;
        border-bottom: 2px solid #ccc; /* 边框的颜色和宽度 */
        height: 32px;
    }

    /* 当Tab激活时，边框颜色可以改变 */
    /deep/ .van-tab--active {
        border-color: #3f51b5; /* 激活状态下的边框颜色 */
    }

</style>
